<template lang="pug">
  .manageUnits
    //- Barra de navegación
    van-nav-bar(
      :title="$t('settings.units')"
      left-arrow
      @click-left="close()"
    )

    .main
      van-cell-group

        //- Unidades input
        van-cell(
          v-for="(unitType, key) in units"
          :title="unitName(unitType)"
          :key="key"
          @click="setUnit(unitType)")
          van-icon(
            v-if="unitType === installationUnit"
            slot="right-icon"
            name="save"
            class="van-cell__right-icon text-brand")
</template>

<script>
import { UNITS } from '@/app.config';
import { UnitFilter, UnitNameFilter } from '@/filters/Temp.filter';

export default {
  filters: { UnitFilter, UnitNameFilter },
  data() {
    return {
      units: UNITS,
    };
  },
  props: {
    installationUnit: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    /**
     * Devuelve el nombre de una unidad de temperatura
     *
     * @returns {String} - Nombre de la unidad de temperatura
     */
    unitName(unit) {
      const nameUnit = this.$options.filters.UnitNameFilter(unit);
      const unitType = this.$options.filters.UnitFilter(unit);
      return `${nameUnit} (${unitType})`;
    },

    /**
     * Lanza un evento cuando se selecciona una unidad
     */
    setUnit(unit) {
      this.$emit('setUnit', unit);
    },

    /**
     * Lanza el evento para cerrar el componente
     */
    close() {
      this.$emit('close');
    },
  },
};
</script>
